import { render, staticRenderFns } from "./AdminPayerMerge.vue?vue&type=template&id=7d37e580&scoped=true"
import script from "./AdminPayerMerge.vue?vue&type=script&lang=js"
export * from "./AdminPayerMerge.vue?vue&type=script&lang=js"
import style0 from "./AdminPayerMerge.vue?vue&type=style&index=0&id=7d37e580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d37e580",
  null
  
)

export default component.exports